/**
 * ICU parameters for `errors.<CODE>` from the API's `details` (T4 §2.4): the API speaks seconds, the messages
 * speak minutes. Other details pass through unchanged.
 */
export function errorParams(_code: string, details: unknown): Record<string, unknown> {
  if (typeof details !== 'object' || details === null) return {};
  const params: Record<string, unknown> = { ...details };
  const seconds = params.retryAfterSec;
  if (typeof seconds === 'number' && Number.isFinite(seconds)) {
    params.minutes = Math.max(1, Math.ceil(seconds / 60));
  }
  return params;
}
